'use client'

import { useAppDispatch } from '@/redux/hooks'
import { setIsLightTheme } from '@/shared/model/themeSlice'
import { PropsWithChildren, ReactElement, useEffect } from 'react'
import { useCookies } from 'react-cookie'
import { useLocalStorage } from 'usehooks-ts'

export const ThemeProviderClient = ({ children }: PropsWithChildren) => {
    const [rejectCookie, setRejectCookie] = useLocalStorage('rejectCookie', '')
    const [cookie, setCookie, removeCookie] = useCookies(['isLightTheme', 'crsf'])
    const [isLightTheme, setLightTheme] = useLocalStorage('isLightTheme', false)

    useEffect(() => {
        if (rejectCookie) {
            removeCookie('crsf')
            removeCookie('isLightTheme')
        }
    }, [rejectCookie])

    const dispatch = useAppDispatch()

    useEffect(() => {
        dispatch(setIsLightTheme(isLightTheme))
    }, [dispatch])

    return children as ReactElement
}
